import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import ClientLink from "./client-link";
import { getClientDetail, getClientDeals } from "../../store/clients/actions"
import ClientSidebar from "components/VerticalLayout/ClientSidebar";

import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Table,
} from "reactstrap"
import { API_URL } from "helpers/app_url";
import axios from "axios";
import Moment from "react-moment";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import LineBreadcrumbs from "components/Common/LineBreadcrumb";
import client from "pages/Client/client";
import clientDeal from "./client-deal";
class ClientDashbord extends Component {
  constructor(props) {
    super(props)
    this.state = {
       expandedRows: null, 
      reports: [

      
        {
          title: "Active Clients ",
          iconClass: "bx-purchase-tag-alt",
          description: "5",
        },
        {
          title: "Forecasted Revenue",
          iconClass: "bx-purchase-tag-alt",
          description: "$100,000",
        },
        {
          title: "Monthaly Goal",
          iconClass: "bx-purchase-tag-alt",
          description: "$150,000",
        },
      ]
    }
  }
  componentDidMount() {
    const { match: { params }, onGetClientDetail, onGetClientDeals } = this.props;
    onGetClientDetail(params.clientId);
    onGetClientDeals(localStorage.getItem('userId'), params.id)
    this.fetchClientActivity();
    this.fetchClientUpcomingShowings();
  }
  fetchClientActivity() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    const params = {
      agentId: localStorage.getItem("userId"),
      clientId: this.props.match.params.id,
    };
    axios
      .get(`${API_URL}ClientListingActivity/allforagent`, { headers, params })
      .then((response) => {

        this.setState({ clientActivities: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
  getType = (type) => {
    if (type == 1)
      return 'Buyer';
    else if (type == 2)
      return 'Seller';
    else if (type == 3)
      return 'Openhouse';
  }
  getListingSubType = (type) => {
    if (type == 1)
      return 'Listing Added';
    else if (type == 2)
      return 'Scheduled';
    else if (type == 3)
      return 'Re-scheduled Request';
    else if (type == 5)
      return 'Message';
    else if (type == 6)
      return 'Offer sent';
    else if (type == 7)
      return 'Offer Accepted';
    else if (type == 8)
      return 'Widthdrawn';
    else if (type == 9)
      return 'Rejected';
  }

  getOpenHouse = (type) => {
    if (type == 22)
      return 'Scheduled';
    else if (type == 23)
      return 'Updated';
  }
  getSellerListingSubType = (type) => {
    if (type == 11)
      return 'Listing Added';
    else if (type == 12)
      return 'Scheduled';
    else if (type == 16)
      return 'Offer Received';
    else if (type == 17)
      return 'Offer Accepted';
    else if (type == 18)
      return 'Widthdrawn';
    else if (type == 19)
      return 'Rejected';
  }
  fetchClientUpcomingShowings() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    const params = {
      agentId: localStorage.getItem("userId"),
      clientId: this.props.match.params.id,
    };
    axios
      .get(`${API_URL}ClientExt/allupcomingshowings`, { headers, params })
      .then((response) => {
        this.setState({ clientListings: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
  getBuyerType = (type) => {
    if (type == 1)
      return 'Rent';
    else if (type == 2)
      return 'Purchase';

  }

  getSellerType = (type) => {
    if (type == 1)
      return 'Sell';
    else if (type == 2)
      return 'Lease';

  }
  getCommType = (type) => {
    if (type == 3)
      return 'Fixed';
    else if (type == 4)
      return '%';

  }
  render() {
    const { clietDetail, deals, isResponsive } = this.props;
    return (
      <React.Fragment>
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Client Dashboard | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0">
            <Row>
              <Col sm='2' className="pe-0">
                <ClientSidebar id={this.props.match.params.id} clientId={this.props.match.params.clientId} clientDetail={clietDetail} isResponsive={isResponsive} />
              </Col>
              <Col sm='10' className="">
                <Row className="project-header">
                  <Col sm='7'>
                    <LineBreadcrumbs
                      title={this.props.t("Clients")}
                      breadcrumbItem={this.props.t(" Dashboard")}
                    />
                  </Col>
                  <Col sm="4" className="">
                    <h2 className="mb-0">{this.props.t(clietDetail.firstName + " " + clietDetail.lastName)}</h2>
                    <span>{clietDetail?.userLogin?.userName == 'Not Authorized' ? 'Client access disabled' : clietDetail?.userLogin?.userName}</span>
                  </Col>
                </Row>
                <Row>



                  <Col xl="12">
                    <Card className="border-full mt-4">
                      <CardBody>
                        <Row>
                          <Col sm="12">


                            <h5 className="card-title">Activity </h5>
                            {isResponsive ? (
                              <DataTable
                                value={this.state.clientActivities || []}
                                dataKey="id"
                                responsiveLayout="stack"
                                expandedRows={this.state.expandedRows}
                                onRowToggle={(e) => this.setState({ expandedRows: e.data })}
                                paginator
                                rows={5}
                                rowExpansionTemplate={(rowData) => (
                                  <table className="table table-bordered mb-0">
                                    <tbody>
                                      <tr>
                                        <th style={{ width: '40%' }}>Listing Address</th>
                                        <td>{rowData.clientListingActivityListingAddress || '-'}</td>
                                      </tr>
                                      
                                    </tbody>
                                  </table>
                                )}
                              >

                                <Column expander style={{ width: '3em' }} />
                                <Column
                                  header="#"
                                  body={(rowData, options) => options.rowIndex + 1}
                                  style={{ width: '60px' }}
                                />

                                <Column
                                  field="addedDate"
                                  header="Date"
                                  body={(rowData) => (
                                    rowData.addedDate ? <Moment format="DD MMM, YYYY">{rowData.addedDate}</Moment> : "N/A"
                                  )}
                                />
                                <Column
                                  field="clientListingActivityListing"
                                  header="Listing ID"
                                  body={(rowData) => rowData.clientListingActivityListing || "N/A"}
                                />
                                 <Column
                                  field="clientListingActivityType"
                                  header="Type"
                                   body={(rowData) => {
                                    const type = rowData.clientListingActivityType;
                                    const subType = rowData.clientListingActivitySubType;
                                    const prefix = this.getType(type) + "-";

                                    if (type === 1) {
                                      return prefix + (this.getListingSubType(subType) || "N/A");
                                    } else if (type === 2) {
                                      return prefix + (this.getSellerListingSubType(subType) || "N/A");
                                    } else {
                                      return prefix + (this.getOpenHouse(subType) || "N/A");
                                    }
                                  }}
                                />
                               
                              </DataTable>
                            ) : (
                              <DataTable
                                className=""
                                stripedRows
                                value={this.state.clientActivities || []}
                                paginator
                                rows={5}
                                rowsPerPageOptions={[5, 10, 20, 30, 50, 100, 150, 200, 500]}
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                tableStyle={{ minWidth: "50rem" }}
                              >
                                 <Column
                                  header="#"
                                   headerClassName="header-bg-table"
                                  body={(rowData, options) => options.rowIndex + 1}
                                  style={{ width: '60px' }}
                                />
                                <Column
                                  headerClassName="header-bg-table"
                                  field="showingDate"
                                  header="Date"
                                  body={(rowData) =>
                                    rowData.addedDate ? <Moment format="DD MMM, YYYY">{rowData.addedDate}</Moment> : "N/A"
                                  }
                                />

                                <Column headerClassName="header-bg-table" field="clientListingActivityListing" header="Listing Id" body={(rowData) => rowData.clientListingActivityListing || "N/A"} />

                                <Column headerClassName="header-bg-table" field="clientListingActivityListingAddress" header="Listing Address" body={(rowData) => rowData.clientListingActivityListingAddress} />
                                <Column
                                  headerClassName="header-bg-table"
                                  field="clientListingActivitySubType"
                                  header="Type"
                                  body={(rowData) => {
                                    const type = rowData.clientListingActivityType;
                                    const subType = rowData.clientListingActivitySubType;
                                    const prefix = this.getType(type) + "-";

                                    if (type === 1) {
                                      return prefix + (this.getListingSubType(subType) || "N/A");
                                    } else if (type === 2) {
                                      return prefix + (this.getSellerListingSubType(subType) || "N/A");
                                    } else {
                                      return prefix + (this.getOpenHouse(subType) || "N/A");
                                    }
                                  }}
                                />


                              </DataTable>
                            )}




                          </Col>




                        </Row>
                      </CardBody>
                    </Card>

                    <Row>

                      <Col sm="8">
                        <Card className="border-full mt-4">
                          <CardBody>
                            <h5 className="card-title">Upcoming showings   Next 7 days</h5>
                            <div className="table-wrapper table-wrapper-scroll">
                              {isResponsive ? (
                                 <table className="table mb-0 table table-striped">
                                <thead>
                                  <tr>
                                   
                                    <th>Date</th>
                                    <th>Time</th>
                                    <th>Listing</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.clientListings && this.state.clientListings.map((listing, index) => {
                                    const isOpen = this.state.openRow === index;
                                    const toggleRow = () => this.setState({ openRow: isOpen ? null : index });

                                    return (
                                      <React.Fragment key={index}>
                                       
                                        <tr onClick={toggleRow} style={{ cursor: 'pointer', background: isOpen ? '#f8f9fa' : 'transparent' }}>
                                            
                                          <td><Moment format="DD MMM, YYYY">{listing.showingDate}</Moment></td>
                                          <td>{listing.startTime || '-'}</td>
                                          <td>
                                            {listing.mlsId}
                                            <i className={`bx ${isOpen ? "bx-chevron-up" : "bx-chevron-down"} float-end`}></i>
                                          </td>
                                        </tr>

                                      
                                        {isOpen && (
                                          <tr>
                                            <td colSpan="2" className="bg-light">
                                              <div><strong>Time:</strong> {listing.startTime || 'N/A'}</div>
                                              <div><strong>Address:</strong> {listing.listingAddress || 'N/A'}</div>
                                              <div><strong>Type:</strong> 
                                              {listing.showingTypeId === 1
                                            ? "Buyer"
                                            : listing.showingTypeId === 2
                                            ? "Seller"
                                            : listing.showingTypeId === 3
                                            ? "Open House"
                                            : "N/A"}</div>
                                              <div><strong>Route plan:</strong> {listing.routeInfo ? 'Set' : 'Not Set'}</div>
                                            </td>
                                          </tr>
                                        )}
                                      </React.Fragment>
                                    );
                                  })}
                                </tbody>
                              </table>
                              ):(
                                  <table className="table mb-0 table table-striped">
                                <thead className="">
                                  <tr>
                                    
                                    <th>Date</th>
                                    <th>Time</th>

                                    <th>Listing</th>
                                    <th>Address</th>
                                    <th>Type</th>
                                    <th>Route plan</th>

                                  </tr>
                                </thead>
                               <tbody>
                                  {this.state.clientListings && this.state.clientListings.length > 0 ? (
                                    this.state.clientListings.map((listing, index) => (
                                      <tr key={index}>
                                        <td><Moment format="DD MMM, YYYY">{listing.showingDate}</Moment></td>
                                        <td>{listing.startTime}</td>
                                        <td>{listing.mlsId}</td>
                                        <td>{listing.listingAddress}</td>
                                        <td>
                                          {listing.showingTypeId === 1
                                            ? "Buyer"
                                            : listing.showingTypeId === 2
                                            ? "Seller"
                                            : listing.showingTypeId === 3
                                            ? "Open House"
                                            : "N/A"}
                                        </td>
                                        <td>{listing.routeInfo ? 'Set' : 'Not Set'}</td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan="6" style={{ textAlign: "center", padding: "10px" }}>
                                        No showings found
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                              )}
                            
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                      <Col sm="4">
                        <Card className="border-full mt-4">
                          <CardBody>
                            <h5 className="card-title w-100">Current Deals <Link to={`/clients/activity/deal/${this.props.match.params.id}/${this.props.match.params.clientId}`} className="float-end">Go to Deals</Link></h5>
                            <div className="table-wrapper table-wrapper-scroll">
                              <table className="table mb-0 table table-striped">
                                <thead className="">
                                  <tr>
                                    <th>Start date</th>
                                    <th>Type</th>

                                    <th>Amount</th>


                                  </tr>

                                </thead>
                                <tbody>
                                  {deals && deals
                                    .filter(deal => deal.clientEngagementStatus === 1)
                                    .map((deal, index) => (
                                      <tr key={index}>
                                        <td><Moment format="DD MMM, YYYY">{deal.lastAgreementDate}</Moment></td>
                                        <td>
                                          {(() => {
                                            if (deal.isBuyer) {
                                              return `Buyer${deal.buyerType ? ` - ${this.getBuyerType(deal.buyerType)}` : ""}`;
                                            }
                                            if (deal.isSeller) {
                                              return `Seller${deal.sellerType ? ` - ${this.getSellerType(deal.sellerType)}` : ""}`;
                                            }
                                            if (deal.isInvestor) {
                                              return "Investor";
                                            }
                                            return "N/A";
                                          })()}
                                        </td>
                                        <td>${deal?.transactionAmount?.toFixed(2) || "0.00"}</td>
                                      </tr>
                                    ))}
                                </tbody>
                              </table>
                            </div>
                          </CardBody>
                        </Card>
                      </Col>

                    </Row>


                  </Col>
                </Row>
              </Col>
            </Row>

          </Container>
        </div>
      </React.Fragment>
    )
  }
}
ClientDashbord.propTypes = {
  t: PropTypes.any,
  match: PropTypes.object,
  onGetClientDetail: PropTypes.func,
  clietDetail: PropTypes.object,
  onGetClientDeals: PropTypes.func,
  deals: PropTypes.array,
  isResponsive: PropTypes.object
}
const mapStateToProps = ({ Clients }) => (
  //,
  {
    clietDetail: Clients.clietDetail,
    deals: Clients.deals,
  })
const mapDispatchToProps = dispatch => ({
  onGetClientDetail: clientId => dispatch(getClientDetail(clientId)),
  onGetClientDeals: (agentId, clientId) => dispatch(getClientDeals(agentId, clientId)),
});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ClientDashbord))
